import { Colour } from 'components/variables'
import * as React from 'react'

import classNames from 'classnames'
import './Layout.scss'

interface LayoutProps {
  color?: Colour
  whiteBackground?: boolean
  children?: React.ReactNode | undefined
}

const Layout: React.FC<LayoutProps> = props => {
  const className = classNames(
    `layout-${props.color}`,
    props.whiteBackground ? `use-white-background` : '',
  )

  return (
    <main className={className} role="main">
      {props.children}
    </main>
  )
}

Layout.defaultProps = {
  color: Colour.turquoise,
}

export default Layout
